/* eslint-disable react/jsx-handler-names */
// Components
import WelcomeBonusInfoFirst from "components/molecules/WelcomeBonusInfoFirst";
import WelcomeBonusInfoRules from "components/molecules/WelcomeBonusInfoRules";
import WelcomeDescription from "components/molecules/WelcomeDescription";

// Constants
import { STORAGE_USER_COUNTRY } from "constants/variables";
import { welcomeBonusCurrencyValues } from "constants/welcomeBonus";

// Helpers
import { getUserCurrency } from "helpers/welcomeBonusCurrency";

// Types
import { UserState } from "redux/user/slice";
import { WelcomeBonusCurrencyBlockValues } from "types/WelcomeBonus";

// Utils
import { getLocalStorageItem } from "utils/localStorage";

import "./styles.sass";

type WelcomeBonusInfoProps = {
  user: UserState;
  onClick: () => void;
};

const WelcomeBonusInfo = (props: WelcomeBonusInfoProps) => {
  const { user, onClick } = props;
  const currentCountry = getLocalStorageItem(STORAGE_USER_COUNTRY);
  const currency = getUserCurrency(user, currentCountry);
  const blockValues: WelcomeBonusCurrencyBlockValues =
    welcomeBonusCurrencyValues[currency];

  return (
    <div className="WelcomeBonusInfo">
      <WelcomeBonusInfoFirst currencyValues={blockValues} onClick={onClick} />
      <WelcomeBonusInfoRules currencyValues={blockValues} />
      <WelcomeDescription />
    </div>
  );
};

export default WelcomeBonusInfo;
